// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"a8e99354","160":"b1d4eccb","208":"e438f591","293":"42448c47","516":"1e3b5a5d","519":"78c90c49","917":"dda04039","946":"dc38a8a0"}[chunkId] + ".chunk.js";
};